import { MenuItem, Select, Stack, Typography } from "~/common/mui";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { MediaFormFields } from "~/features/mediaLibrary/types/mediaLibraryFormTypes";

export default function SortByFilter() {
  const { control } = useFormContext<MediaFormFields>();
  const { t } = useTranslation();

  return (
    <Controller
      name="sortOrder"
      control={control}
      render={({ field: { value, onChange } }) => (
        <Stack direction="column">
          <Typography variant="bodySmall" sx={{ mb: 1 }}>
            {t("media.library.sortBy")}
          </Typography>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={value}
            onChange={onChange}
            size="small"
            sx={{ borderRadius: 1 }}
          >
            <MenuItem value={"asc"}>{t("media.library.sortAlphabeticalAsc")}</MenuItem>
            <MenuItem value={"desc"}>{t("media.library.sortAlphabeticalDesc")}</MenuItem>
          </Select>
        </Stack>
      )}
    />
  );
}
